export const getChatMessages = (storeState) => storeState.messages.sort((a, b) => {
  if (a.timestamp === null || b.timestamp === null) {
    return 0;
  }

  if (a.timestamp > b.timestamp) {
    return 1;
  }

  return -1;
});

export const shouldShowTranslateButton = (storeState) => Boolean(
  storeState.messages.find((msg) => Boolean(
    msg.translation_status > 0 ||
    typeof msg.translated_message === 'string'
  ))
);
